







































import Vue from 'vue';
import { mapState } from 'vuex';
import Helpers from '@/mixins/helpers';
import Api from '@/mixins/api';
import axios from 'axios';
import { ValueAddData, ValueAddApiResultItem } from '@/types.d';
import Analytics from '@/mixins/analytics';

export default Vue.extend({
    name: 'ValueAdd', 
    computed: {
		...mapState({
			valueAdd(): any { return this.$store.state.valueAdd },
			dealer(): any { return this.$store.state.dealer },
			vehicle(): any { return this.$store.state.vehicle }
		}), 
        valueAdds: {
            get(): Array<ValueAddData> {
				return this.valueAdd.data;
			}
        }
	}, 
    methods: {
        doesTitleContainGenuineAccessories(title: string): boolean {
            return title.toLowerCase().includes('genuine accessories');
        },
        getVaTitleDisclaimers(title: string){
            if (this.doesTitleContainGenuineAccessories(title)){
                return '[**]';
            }
            return '';
        },
        handleValueAddChange(id: number): void {
            const vas: Array<ValueAddData> = Array.from(this.valueAdds);
            const selectedVa: Array<ValueAddData> = vas.filter((o: ValueAddData) => o.id == id);
            if (selectedVa.length){
                selectedVa[0].selected = !selectedVa[0].selected;
                this.$store.commit('setValueAdd', vas);
                this.$store.commit('setValueAddAnalytics', false);
            }
        },
        getData(): void {
            // do api call
            const url = Api.getValueAddURL(this.dealer.dealerID, this.vehicle.vehicleType);
            Helpers.clog(url);
            axios.get(`${url}`).then((response: any) => {
                Helpers.clog(response.data);
                if (response.data && typeof response.data == 'object' && response.data.length){
                    const newData: Array<ValueAddData> = response.data.map((o: ValueAddApiResultItem) => {
                        // o.Name is category name 
                        let iconName = '';
                        switch (o.Name){
                            case "exterior":
                                iconName = 'bullbar';
                                break;
                            case "interior":
                                iconName = 'seating';
                                break;
                            case "services":
                                iconName = 'vehicle';
                                break;
                        }
                        return {
                            id: o.id,
                            title: o.Title,
                            text: o.Description,
                            icon: iconName,
                            selected: false, 
                            analytics: o.Name.replace(/\w\S*/g, function(txt: string){
                                return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
                            })
                        };
                    });
                    this.$store.commit('setValueAdd', newData);
                }
                else {
                    Helpers.clog('no ValueAdd data, hiding.');
                    this.$store.commit('setApp', {
                        showValueAdd: false
                    });
                }
            });
        }
    },
    mounted(): void {
        if (!this.valueAdd.hasRetrievedData && this.vehicle.vehicleType){
            this.getData();
        }
    }, 
    beforeDestroy(){
        if (!this.valueAdd.hasSentAnalytics){
            Analytics.sendEventFull({
                "event": "valueAdd",
                "eventCategory": "User Interactions",
                "eventAction": "Value Add Option - Submitted",
                "eventLabel" : this.valueAdds.filter((o: ValueAddData) => o.selected).map((o: ValueAddData) => o.analytics).join("|")
            });
            this.$store.commit('setValueAddAnalytics', true);
        }
    }
});
